enum Method {
    Lookup = 'Lookup',
     Indexed = 'Indexed',
}

export default Method;